import type { CoBuyer, CommonConsumer } from '@makemydeal/dr-platform-types';
import { combineCommonConsumerContactInfo } from './buyerUtils';
import { SPACE_DELIMITER } from '../constants/meta';

export const transformCommonConsumerToCoBuyer = (
    original: Partial<CoBuyer> = {},
    consumer: CommonConsumer,
    allowEmptyValues: boolean,
    optionalDesking: boolean = false,
    isPostalCodeDigitsOnlyValidationEnabled: boolean = false
): CoBuyer => {
    // TODO: combineCommonConsumerContactInfo as any needs to have a supported type (if we intend on combining them in the future)
    const contact: Partial<CoBuyer> = combineCommonConsumerContactInfo(
        original as any,
        consumer,
        allowEmptyValues,
        optionalDesking,
        isPostalCodeDigitsOnlyValidationEnabled
    );
    return contact as CoBuyer;
};

export const coBuyerSuffixToProperCase = (suffix: string | undefined): string => {
    let properSuffix = suffix;
    if (suffix) {
        properSuffix = suffix
            .split(SPACE_DELIMITER)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(SPACE_DELIMITER);
    }
    return properSuffix || '';
};
